// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__ImvFp","closeCouponDrawerContainer":"styles_closeCouponDrawerContainer__1uiF3","closeCouponDrawer":"styles_closeCouponDrawer__3H-EW"};